import { useTranslation } from 'react-i18next';
import AppLayout from '../../components/AppLayout';
import { S, Icon } from '../regureStyles';
import CreateModal from './CreateModal';
import Filter from './Filter';
import Header from './Header';
import NoRequests from './NoRequests';

import Table from './Table';
import useESgnatureFunctions from './useESgnatureFunctions';

// ─── Main Screen ──────────────────────────────────────────
const ESignaturesScreen = () => {
  const { t } = useTranslation();
  const { history, requests, loading, error, statusFilter, setStatusFilter, showCreate, setShowCreate, fetchRequests, handleCreated } = useESgnatureFunctions();

  return (
    <AppLayout>
      {showCreate && <CreateModal onClose={() => setShowCreate(false)} onCreated={handleCreated} />}

      <div style={{ display: 'flex', flexDirection: 'column', height: '100%', overflowY: 'auto' }}>
        {/* Header */}
        <Header setShowCreate={setShowCreate} />

        <div style={{ flex: 1, padding: '24px 32px' }}>
          {/* Filter bar */}
          <Filter statusFilter={statusFilter} setStatusFilter={setStatusFilter} />

          {/* Content */}
          {loading ? (
            <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
              {[1, 2, 3].map(i => (
                <div key={i} style={{ height: 64, background: S.bgCard, borderRadius: 12, border: `1px solid ${S.borderLight}` }} />
              ))}
            </div>
          ) : error ? (
            <div style={{ textAlign: 'center', padding: 48 }}>
              <Icon name='alert-circle' color={S.danger} size={32} />
              <div style={{ marginTop: 12, color: S.danger, fontWeight: 600 }}>{error}</div>
              <button
                onClick={fetchRequests}
                style={{ marginTop: 12, padding: '8px 20px', background: S.burgundy, color: '#fff', border: 'none', borderRadius: 8, cursor: 'pointer', fontWeight: 600 }}
              >
                {t('screens.esign.retry')}
              </button>
            </div>
          ) : !requests?.length ? (
            <NoRequests statusFilter={statusFilter} setShowCreate={setShowCreate} />
          ) : (
            <Table requests={requests} history={history} />
          )}
        </div>
      </div>
    </AppLayout>
  );
};

export default ESignaturesScreen;
